import { MediaQueryAllQueryable, useMediaQuery } from "react-responsive";

const BREAK_POINTS: {
   [key: string]: Readonly<Partial<
    MediaQueryAllQueryable & {
      query?: string | undefined;
    }
  >>;
} = {
  sm: { minWidth: 640 },
  xl: { minWidth: 1280 },
  lg: { minWidth: 1024 },
  md: { minWidth: 768 },
} 
export const { xs, sm, xl, lg, md } = BREAK_POINTS;

export const useBreakPoint = (
  breakpoint: Partial<
    MediaQueryAllQueryable & {
      query?: string | undefined;
    }
  >
) => {
  checkBreakPoint(breakpoint);
  return useMediaQuery(breakpoint);
};
const checkBreakPoint = (
  breakpoint: Partial<
    MediaQueryAllQueryable & {
      query?: string | undefined;
    }
  >
) => {
  if (Object.values(BREAK_POINTS).indexOf(breakpoint) < 0) {
    throw new Error("break point is unrecognized");
  }
};
